import Common from "./common";

export default class Rest {

    static deleteRent(uuid) {
        return fetch(Common.BASE_API + 'report/rent/' + uuid, {
            method: 'DELETE'
        }).then(function (response) {
            if (response.ok) {
                return Promise.resolve({});
            } else {
                return Promise.reject(response);
            }
        });
    }


    static printGasSummary(id) {
        return fetch(Common.BASE_API + 'report/gassummary/' + id + '/print').then(function (response) {
            if (response.ok) {
                response.json().then(function (response) {
                    window.open(Common.BASE_API + "report/print/" + response.value, '_blank').focus();
                }).catch(function (present) {
                });
            } else {
                return Promise.reject(response);
            }
        });
    }

    static sendSMSWithDocuments(id) {
        return fetch(Common.BASE_API + 'report/rent/' + id + '/documentsms').then(function (response) {
            if (response.ok) {
                response.json().then(function (response) {
                    return Promise.resolve({});
                }).catch(function (present) {
                });
            } else {
                return Promise.reject(response);
            }
        });
    }

    static printRent(id) {
        return fetch(Common.BASE_API + 'report/rent/' + id + '/print').then(function (response) {
            if (response.ok) {
                response.json().then(function (response) {
                    window.open(Common.BASE_API + "report/print/" + response.value, '_blank').focus();
                }).catch(function (present) {
                });
            } else {
                return Promise.reject(response);
            }
        });
    }

    static getLasowiceCashReport() {
        return fetch(Common.BASE_API + 'report/printLasowiceCash').then(function (response) {
            if (response.ok) {
                response.json().then(function (response) {
                    window.open(Common.BASE_API + "report/print/" + response.value, '_blank').focus();
                }).catch(function (present) {
                });
            } else {
                return Promise.reject(response);
            }
        });
    }

    static getAllClients() {
        return fetch(Common.BASE_API + 'report/clients').then(function (response) {
            if (response.ok) {
                return response.json();
            } else {
                return Promise.reject(response);
            }
        });
    }

    static getActualRents() {
        return fetch(Common.BASE_API + 'report/rents/actual').then(function (response) {
            if (response.ok) {
                return response.json();
            } else {
                return Promise.reject(response);
            }
        });
    }

    static getPastRents() {
        return fetch(Common.BASE_API + 'report/rents/past').then(function (response) {
            if (response.ok) {
                return response.json();
            } else {
                return Promise.reject(response);
            }
        });
    }

    static getFutureRents() {
        return fetch(Common.BASE_API + 'report/rents/future').then(function (response) {
            if (response.ok) {
                return response.json();
            } else {
                return Promise.reject(response);
            }
        });
    }

    static getCosts() {
        return fetch(Common.BASE_API + 'report/costs').then(function (response) {
            if (response.ok) {
                return response.json();
            } else {
                return Promise.reject(response);
            }
        });
    }

    static getInvoiceUuid(rentId) {
        return fetch(Common.BASE_API + 'report/invoice/' + rentId).then(function (response) {
            if (response.ok) {
                return response.json();
            } else {
                return Promise.reject(response);
            }
        });
    }

    static generateInvoice(dto) {
        return fetch(Common.BASE_API + 'report/invoice', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'uuid': Cookies.get('uuid')
            },
            body: JSON.stringify(dto)
        }).then(function (response) {
            if (response.ok) {
                return Promise.resolve({});
            } else {
                return Promise.reject(response);
            }
        });
    }

    static sendLinkToPayment(dto) {
        return fetch(Common.BASE_API + 'report/stripe', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'uuid': Cookies.get('uuid')
            },
            body: JSON.stringify(dto)
        }).then(function (response) {
            if (response.ok) {
                return Promise.resolve({});
            } else {
                return Promise.reject(response);
            }
        });
    }

    static saveClient(client) {
        return fetch(Common.BASE_API + 'report/client', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'uuid': Cookies.get('uuid')
            },
            body: JSON.stringify(client)
        }).then(function (response) {
            if (response.ok) {
                return Promise.resolve({});
            } else {
                return Promise.reject(response);
            }
        });
    }

    static saveCost(rent) {
        if (!rent.uuid) {
            rent.uuid = this.uuid();
        }
        if (!rent.creationDate) {
            rent.creationDate = new Date().getTime();
        }
        return fetch(Common.BASE_API + 'report/cost', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'uuid': Cookies.get('uuid')
            },
            body: JSON.stringify(rent)
        }).then(function (response) {
            if (response.ok) {
                return Promise.resolve({});
            } else {
                return Promise.reject(response);
            }
        });
    }

    static uuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    static saveRent(rent) {
        if (!rent.uuid) {
            rent.uuid = this.uuid();
        }
        return fetch(Common.BASE_API + 'report/rent', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'uuid': Cookies.get('uuid')
            },
            body: JSON.stringify(rent)
        }).then(function (response) {
            if (response.ok) {
                return Promise.resolve({});
            } else {
                return Promise.reject(response);
            }
        });
    }


    static savePayment(payment) {
        if (!payment.creationDate) {
            payment.creationDate = new Date().getTime();
        }
        return fetch(Common.BASE_API + 'report/payment', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'uuid': Cookies.get('uuid')
            },
            body: JSON.stringify(payment)
        }).then(function (response) {
            if (response.ok) {
                return Promise.resolve({});
            } else {
                return Promise.reject(response);
            }
        });
    }
};
